import { useState, useEffect, useCallback } from 'react'
import { useAdminMode } from './useAdminMode'

export const useCommandPalette = () => {
  const [isOpen, setIsOpen] = useState(false)
  const isAdmin = useAdminMode()

  const open = useCallback(() => {
    if (isAdmin) {
      setIsOpen(true)
    }
  }, [isAdmin])

  const close = useCallback(() => setIsOpen(false), [])

  const toggle = useCallback(() => {
    if (isAdmin) {
      setIsOpen(prev => !prev)
    }
  }, [isAdmin])

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Cmd+K (Mac) or Ctrl+K (Windows/Linux)
      // Only allow if admin mode is active
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault()
        if (isAdmin) {
          toggle()
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [toggle, isAdmin])

  return {
    isOpen,
    open,
    close,
    toggle
  }
}

export default useCommandPalette